import React, { useState, useEffect } from 'react';
import { Tabs, Space } from 'antd';
import type { TabsProps } from 'antd';
import { Button, Form } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import axios from 'axios';
import SweetAlert from "sweetalert2";
import { Alert, Box, Typography } from '@mui/material';
import { useAuthHeader, useAuthUser } from '../../../../Services/Auth/sessionAuth';
import Swal from 'sweetalert2';
import DataPeriod1 from "../../../../Functions/Traitement/DataPeriodAuto"
import link from '../../../../Data/Data.json';
import formatDate from '../../../../Functions/Traitement/fomatDate' //'../../../function/FormDate';
import ReformatDate from '../../../../Functions/Traitement/ReformatDate'
import Table, { ColumnsType } from 'antd/es/table';
import { Spin } from 'antd';
import Data from '../../../../Data/Data.json'
import { Crypter } from '../../../../Functions/Security/Crypter';
import Utilisateur from '../../../../Models/Utilisateur';
import DataType from "../../../../Functions/Traitement/DataPeriodAuto";
import InputForm from "../../../InputT";


const InvalidAutorisation = () => {
    //state pour la recherche

    const [SearchR, SetSearchR] = useState<string>("");

    // DECLARATION DES COLONNES DU TABLEAU
    const columns: ColumnsType<DataType> = [
        {
            title: 'Numéro découvert',
            dataIndex: 'NUMCRD',
            filteredValue: [SearchR],
            onFilter: (value: any, record: any) => {
                return String(record.NUMCRD)
                    .toLowerCase()
                    .includes(value.toLowerCase()) ||
                    String(record.NUMCLI)
                        .toLowerCase()
                        .includes(value.toLowerCase()) ||
                    String(record.NOMCLI)
                        .toLowerCase()
                        .includes(value.toLowerCase()) ||
                    String(record.SERVGE)
                        .toLowerCase()
                        .includes(value.toLowerCase())
            }

        },
        {
            title: 'ID client',
            dataIndex: 'NUMCLI',
        },
        {
            title: 'Nom client',
            dataIndex: 'NOMCLI',
        },
        {
            title: 'Status',
            dataIndex: 'CDETAT',
        },
        {
            title: 'Nature découvert',
            dataIndex: 'NATCRD',
        },
        {
            title: 'Montant',
            dataIndex: 'MNTAUT',
        },
        {
            title: 'Date effet',
            dataIndex: 'DATEFF',
        },
        {
            title: 'Date fin',
            dataIndex: 'DATEFIN',
        }, {
            title: 'Numéro compte',
            dataIndex: 'CPTAUT'
        }
    ];

    // USER SESSION
    const auth = useAuthUser()
    const Perss: Utilisateur = JSON.parse(JSON.stringify(auth()))


    // declaration des usestates
    const authHeader = useAuthHeader()
    const [form] = Form.useForm();
    const [, forceUpdate] = useState({});
    const [ajoutActve, setAjoutActif] = useState(true)
    const [impActive, setImpActive] = useState(false)
    const [isSubmit, setIsSubmit] = useState(false)

    useEffect(() => {
        forceUpdate({});
    }, []);

    //****************************************** New Reason  */
    // Handle pour la selection des element dans le tableau
    const [loading, setLoading] = useState(false);
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    const [donnees, setData] = useState<DataType[]>([]);


    const onSelectChange = (newSelectedRowKeys: any) => {
        console.log('selectedRowKeys changed :) ', donnees[newSelectedRowKeys]);
        setSelectedRowKeys(newSelectedRowKeys);

        sessionStorage.setItem(Data.LocalVariable.FourthValueAuto, Crypter.encrypt(donnees[newSelectedRowKeys].NUMCRD))
        ConsultTab()

    };
    const rowSelection = {
        onChange: onSelectChange,
        selectedRowKeys,
    };

    // GESTION DES ITEMS
    const items: TabsProps['items'] = [
        {
            key: '5',
            label: (
                <span id='Tab'>
                    <UserOutlined />
                    Invalider Découvert
                </span>
            ),
            children: <>

                <div className='tabItem' >

                    <div style={{ display: 'block flow' }}  >
                        <Box fontStyle="inherit" className='border' width={"85%"} position={"absolute"} sx={{ p: 1 }} >
                            <legend> Listes des Découverts valides </legend>
                            <Box className='border' style={{width:'100%' }} sx={{mb:1}}>
                                <InputForm notRequired onChange={(e: any) => { SetSearchR(e.target.value.trim()); }} label={'Recherche'} name="Element" type="string" />
                            </Box>
                            <Box className='border' style={{width:'100%' }} display={"-ms-grid"} fontStyle="inherit" >
                                <Spin spinning={loading}>
                                    <Table dataSource={donnees} rowSelection={{ ...rowSelection, type: "radio", getCheckboxProps: (reccord) => ({ disabled: false }) }} style={{ textAlign: "center", width: '100%' }} columns={columns} size='small' pagination={false} scroll={{ y: 400, x: 400 }} />
                                </Spin>
                            </Box>

                        </Box>
                    </div>
                </div >
            </>
        },
    ];

    const onFinishFailed = (errorInfo: any) => {
        setLoading(true);
        setLoading(false);
    };




    //    function affichage avant validation
    function ConsultTab() {

        let data1 = Crypter.encrypt('2');
        let data2 = Crypter.encrypt(Perss.codage)

        if (data1.length != 0 && data2.length != 0) {

            setLoading(true);
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: Data.ApiUrl.ConsultTabPeriode,
                headers: {
                    'CypherChoix': data1,
                    'CypherCodeage': data2,
                    'Authorization': authHeader(),
                    'Content-Type': 'application/json'
                },
            };


            // MAPPING DANS LE TABLEAU
            let dat: DataPeriod1[] = [];

            axios.request(config)
                .then((response) => {
                    setLoading(false);

                    //alert('one 1++' + response.data)
                    if (response.data) {


                        let datas1 = JSON.parse(Crypter.decrypt(response.data));
                        let datas = (datas1.Result);



                        datas.map((val: any, key: any) => {
                            dat.push({
                                key: key,
                                NUMCRD: val.NUMCRD,
                                NUMCLI: val.NUMCLI,
                                NOMCLI: val.NOMCLI,
                                SERVGE: val.SERVGE,
                                NATCRD: val.NATCRD,
                                MNTAUT: val.MNTAUT,
                                DATEFF: val.DATEFF,
                                DATEFIN: val.DATEFIN,
                                CPTAUT: val.CPTAUT,
                                CDETAT:val.CDETAT
                            }
                            )
                        })
                        setData(dat);

                    }
                    setLoading(false)
                })
                .catch((error) => {
                    setLoading(false);
                    console.log(error)
                    SweetAlert.fire({ title: "ErrorW", text: error, icon: "error" })
                });
        }

    }


    // function onfinish
    const Onfinish = (values: any) => {


        let Numcrd = (Crypter.decrypt((sessionStorage.getItem(Data.LocalVariable.FourthValueAuto) + '')) + "")

        //alert(Numcrd)

        if (Numcrd == "") {
            SweetAlert.fire({ title: "Warning", text: "Operation Impossible : Svp selectionné un Découvert", icon: "warning" })
        } else {

            SweetAlert.fire({
                title: " Cloturation Découvert",
                text: "Voulez-vous Cloturer le Decouvert de Reference: " + Numcrd + " ?",
                showCancelButton: true,
                color: "green",
                confirmButtonText: "Yes",
                confirmButtonColor: "green",
                cancelButtonColor: "darkred",
                cancelButtonText: "No",
                showLoaderOnConfirm: true,
                icon: 'question'
            }).then((res) => {
                if (res.isConfirmed) {
                    setLoading(true);
                    setIsSubmit(true)

                    let data1 = Crypter.encrypt(JSON.stringify(Numcrd));
                    let data2 = Crypter.encrypt(JSON.stringify(Perss.coduti));
                    let data3 = Crypter.encrypt(JSON.stringify(Perss.codage));

                    let config = {
                        method: 'put',
                        maxBodyLength: Infinity,
                        url: Data.ApiUrl.InvalidationAuto,
                        headers: {
                            'CypherNUMCRD': data1,
                            'CypherUTIVAL': data2,
                            'CypherCodeage':data3,
                            'Authorization': authHeader(),
                            'Content-Type': 'application/json'
                        },
                    };
                    axios.request(config)
                        .then((response) => {
                            setLoading(false);
                            if (response.data) {

                                let datas1 = JSON.parse(Crypter.decrypt(response.data));
                                let code = (datas1.Result);

                                if (code == 'ErreurJr') {
                                    SweetAlert.fire({ title: " ", text: "Opération Impossible: Date comptable n'est pas ouverte " + code, icon: "warning" })
                                } else if (code == 'ErrorEtat') {
                                    SweetAlert.fire({ title: " ", text: "Opération Impossible: la demande n'est pas valide " + code, icon: "warning" })
                                } else if (code == 'ErroUser') {
                                    SweetAlert.fire({ title: " ", text: "Opération Impossible : l'utilisateur qui a validé ne peut invalidé le decouvert" , icon: "warning" })
                                } else {
                                    setIsSubmit(false)
                                    SweetAlert.fire({ title: "", text: "Invalidation  de l'autorisation effectuée avec succès:  reference: " + code, icon: "success" })
                                    localStorage.clear()
                                    form.resetFields()
                                    ConsultTab()
                                }

                            }
                        })
                        .catch((error) => {
                            setLoading(false);
                            console.log(error)
                            SweetAlert.fire({ title: "Error", text: error, icon: "error" })
                        });

                }
            })
        }

        sessionStorage.clear();
        form.resetFields();
        setSelectedRowKeys([]);

    }

    const [Pageloadd, setPageLoadd] = useState(false)
    const [Pageload, setPageLoad] = useState(true);
    // function pour charger la page 
    if (Pageload === true) {

        if (Pageloadd == false) {
            ConsultTab()
            setPageLoad(false)
            setPageLoadd(true)
        }
    }


    return (
        <div className='tab'>
            <Typography align='center' className='formTitle'><b> Invalider Découvert : {window.location.pathname.toUpperCase()}</b></Typography>
            <Spin spinning={loading} size='large' style={{ color: 'green' }} >
                <Form disabled={!ajoutActve} autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinish={Onfinish} onFinishFailed={onFinishFailed} style={{ minWidth: 'auto', maxWidth: 'auto' }}>
                    <div className='bG' style={{ maxWidth: 400 }}>
                        <legend><Typography color={"darkgreen"}>Actions</Typography></legend>
                        <Form.Item shouldUpdate className='bouttong'>
                            <Space direction="vertical" style={{ width: '100%' }}>
                                <Button size='large' className='bt_add' disabled={impActive} onClick={() => { ConsultTab() }} type="ghost" /* htmlType="submit"*/ block  >
                                    Afficher
                                </Button>
                                <Button size='large' className='bt_add' disabled={impActive} onClick={() => { }} type="ghost" htmlType="submit" block  >
                                    Invalider
                                </Button>
                                <Button size='large' className='bt_add' disabled={impActive} onClick={() => { form.resetFields(); setSelectedRowKeys([]); sessionStorage.clear() }} type="ghost" block  >
                                    Actualiser
                                </Button>
                            </Space>
                        </Form.Item>
                    </div>
                    <div className='clientP'>
                        <div >
                            <Tabs size='large' type="card" defaultActiveKey="1" items={items} />
                        </div>
                        <div>
                        </div>
                    </div>
                </Form>
            </Spin>
        </div>
    );
}

export default InvalidAutorisation;